import React from "react";
import Dropdown from "@radarly/components/panels/card-edition/sidebar/dropdown";
import { Card } from "@radarly/models/cards";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { useSort } from "./model";

export interface SortProps {
  dataviz: DatavizHorizontalBarChart;
  setDataviz: (dataviz: DatavizHorizontalBarChart) => void;
  card: Card;
}

export default function Sort({ dataviz, setDataviz, card }: SortProps) {
  const { label, options, onChange, option } = useSort(
    card,
    dataviz,
    setDataviz
  );
  return (
    <Dropdown
      label={label}
      value={option}
      options={options}
      onChange={onChange}
    />
  );
}
